import * as React from 'react';
const SvgLogistics = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlSpace='preserve'
    width='410mm'
    height='597mm'
    viewBox='0 0 410 597'
    {...props}
  >
    <path
      d='M61.963 57.555a15.81 15.81 0 0 0-1.863.128A15.81 15.81 0 0 0 46.044 73.38a15.81 15.81 0 0 0 14.583 15.73 15.81 15.81 0 0 0 .444.03 15.81 15.81 0 0 0 .784.05 15.81 15.81 0 0 0 .55-.022 15.81 15.81 0 0 0 .485-.021 15.81 15.81 0 0 0 .245-.017 15.81 15.81 0 0 0 14.639-15.763 15.81 15.81 0 0 0-15.811-15.811Zm-.035.615a15.81 15.81 0 0 1 11.348 15.153 15.81 15.81 0 0 1-11.387 15.15 15.81 15.81 0 0 1-11.347-15.136A15.81 15.81 0 0 1 61.928 58.17Z'
      style={{
        display: 'inline',
        fill: props.fill || 'none',
        fillOpacity: 0.819608,
        stroke: props.stroke || 'tan',
        strokeWidth: 2.1,
        strokeDasharray: 'none',
        strokeOpacity: 1,
      }}
    />
    <path
      d='M77.163 73.85a15.305 15.836 0 0 0-3.59-10.167 15.305 15.836 0 0 1-11.993 6.003 15.305 15.836 0 0 1-11.696-5.644 15.305 15.836 0 0 0-3.332 9.808 15.305 15.836 0 0 0 3.765 10.397 15.305 15.836 0 0 1 11.599-5.51 15.305 15.836 0 0 1 11.54 5.439 15.305 15.836 0 0 0 3.707-10.326z'
      style={{
        display: 'inline',
        fill: props.fill || 'none',
        fillOpacity: 0.819608,
        stroke: props.stroke || 'tan',
        strokeWidth: 2.1,
        strokeDasharray: 'none',
        strokeOpacity: 1,
      }}
    />
    <path
      d='m46.444 73.544 30.977-.167'
      style={{
        display: 'inline',
        opacity: 1,
        fill: props.fill || 'none',
        fillOpacity: 0.819608,
        stroke: props.stroke || 'tan',
        strokeWidth: 2.1,
        strokeDasharray: 'none',
        strokeOpacity: 1,
      }}
    />
    <path
      d='M98.681 54.946v4.032l.665.4.798.708.089 1.418.015 1.751a1.112 1.112 0 0 0-.129.072h-.497a.247.247 0 0 0-.247.248v2.882c0 .137.11.247.247.247h.003v25.932c0 .61.49 1.1 1.1 1.1h.852a10.479 8.531 0 0 1 10.131-6.415 10.479 8.531 0 0 1 10.15 6.415h2.023c.61 0 1.1-.49 1.1-1.1V79.18a22.445 10.915 53.975 0 0-2.773-5.188 22.445 10.915 53.975 0 0-5.698-7.288h5.545c.137 0 .247-.11.247-.247v-2.882a.247.247 0 0 0-.247-.248h-9.22a22.445 10.915 53.975 0 0-.11-.093h11.48c.044 0 .086.006.129.01-.138-.062-.29-.099-.453-.099h-21.059l-.108-3.413v-3.5l-1.728-1.286Z'
      style={{
        opacity: 1,
        fill: props.fill || 'none',
        fillOpacity: 0.819608,
        stroke: props.stroke || 'tan',
        strokeWidth: 2.1,
        strokeDasharray: 'none',
        strokeOpacity: 1,
      }}
    />
    <path
      d='M104.039 68.224v10.185h14.32l-3.165-5.482-8.351-4.82zM29.833 52.835c-.61 0-1.1.49-1.1 1.1v38.406c0 .61.49 1.1 1.1 1.1h.941a10.479 8.531 0 0 1 10.106-6.319 10.479 8.531 0 0 1 10.117 6.32h22.598a10.479 8.531 0 0 1 10.033-6.083 10.479 8.531 0 0 1 10.026 6.053c.49-.11.856-.546.856-1.07V53.934c0-.61-.49-1.1-1.1-1.1z'
      style={{
        opacity: 1,
        fill: props.fill || 'none',
        fillOpacity: 0.819608,
        stroke: props.stroke || 'tan',
        strokeWidth: 2.1,
        strokeDasharray: 'none',
        strokeOpacity: 1,
      }}
    />
    <path
      d='M40.86 91.163a6.677 6.677 0 0 0-6.677 6.677 6.677 6.677 0 0 0 6.678 6.678 6.677 6.677 0 0 0 6.677-6.678 6.677 6.677 0 0 0-6.677-6.677zm70.688.18a6.677 6.677 0 0 0-6.678 6.677 6.677 6.677 0 0 0 6.678 6.678 6.677 6.677 0 0 0 6.677-6.678 6.677 6.677 0 0 0-6.677-6.677zm-27.889.166a6.677 6.677 0 0 0-6.677 6.678 6.677 6.677 0 0 0 6.677 6.677 6.677 6.677 0 0 0 6.678-6.677 6.677 6.677 0 0 0-6.678-6.678z'
      style={{
        opacity: 1,
        fill: props.fill || 'none',
        fillOpacity: 0.819608,
        stroke: props.stroke || 'tan',
        strokeWidth: 3.23927,
        strokeDasharray: 'none',
        strokeOpacity: 1,
      }}
    />
  </svg>
);
export default SvgLogistics;
